import {SureFlowRatingUnitRequest} from './sure-flow-rating-unit-request';
import {SureFlowRatingUnitResponse} from './sure-flow-rating-unit-response';

export class SureFlowRatingUnit {

  id!: number;
  productId!: string;
  modelCode!: string;
  sizeCode!: string;
  coilRowCode!: string;
  powerSupplyCode!: string;
  motorTypeCode!: string;
  airFilterCode!: string;
  electricHeatCode!: string;
  request!: SureFlowRatingUnitRequest;
  response!: SureFlowRatingUnitResponse;

}
